import request from '@/config/axios'

export interface CircleVO {
  id?: number
  circleName: string
  circleIcon?: string
  circleDesc?: string
  mission?: string
  goalText?: string
  industry?: string
  industryCode?: string
  tagLabels?: string
  officialFlag?: boolean
  coOrganizers?: string
  isPaid?: boolean
  price?: number
  ownerUserId?: number
  ownerNickname?: string
  ownerMobile?: string
  memberCount?: number
  feedCount?: number
  sortOrder?: number
  status?: number
  verifyStatus?: number
  verifyRemark?: string
  verifyTime?: string
  createTime?: string
}
export const getCirclePage = (params: PageParam & { keyword?: string; status?: number; verifyStatus?: number }) =>
  request.get({ url: '/bosscircle/circle/page', params })
export const getCircle = (id: number) => request.get({ url: '/bosscircle/circle/get', params: { id } })
export const createCircle = (data: CircleVO) => request.post({ url: '/bosscircle/circle/create', data })
export const updateCircle = (data: CircleVO) => request.put({ url: '/bosscircle/circle/update', data })
export const deleteCircle = (id: number) => request.delete({ url: `/bosscircle/circle/delete/${id}` })
export const verifyCircle = (data: { id: number; pass: boolean; rejectReason?: string }) =>
  request.put({ url: '/bosscircle/circle/verify', data })
export const getMemberPage = (params: PageParam & { circleId: number }) =>
  request.get({ url: '/bosscircle/circle/member/page', params })
export const removeMember = (circleId: number, memberId: number) =>
  request.delete({ url: '/bosscircle/circle/member/delete', params: { circleId, memberId } })
